import device from 'extensions/device';
import light from 'config/themes/light';
import dark from 'config/themes/dark';
import type {ThemeBase} from 'config/themes/base';

export const theme: ThemeBase = device.isDarkMode() ? dark : light;
